exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-flooringrandr-flooring-r-and-r-tsx": () => import("./../../../src/pages/flooringrandr/FlooringRAndR.tsx" /* webpackChunkName: "component---src-pages-flooringrandr-flooring-r-and-r-tsx" */),
  "component---src-pages-flooringrandr-index-tsx": () => import("./../../../src/pages/flooringrandr/index.tsx" /* webpackChunkName: "component---src-pages-flooringrandr-index-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

